import { SplashPage } from "contexts/Subscription";
import { AddOnItemName } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

export type StripeCustomer = {
  id?: string;
  name: string;
  address: StripeCustomerAddress;
  balance?: number;

  // Only on FE
  payment_method?: PaymentMethod;
};

export type PaymentMethod = {
  id: string;
  card: {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
  };
};

export type StripeCustomerAddress = {
  country: string;
  postal_code: string;
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
};

export type Invoice = {
  id?: string;
  amount_due: number;
  currency: string;
  period_start: number;
  period_end: number;
  next_payment_attempt: number;
  lines: {
    data: StripeInvoiceLineItem[];
  };
  starting_balance: number;
  total_discount_amounts: DiscountAmount[];
  total_taxes: TaxAmount[];
  discounts?: Discount[];
};

export type StripeInvoiceLineItem = {
  amount: number;
  description: string;
  plan: {
    nickname: string;
  };
  period: {
    start: number;
    end: number;
  };
  metadata: {
    item_name?: AddOnItemName;
    start?: number;
    end?: number;
  };
  quantity?: number;
};

export type Discount = {
  coupon: {
    name: string;
  };
  promotion_code?: string;
};

export type DiscountAmount = {
  amount: number;
};

export type TaxAmount = {
  amount: number;
};

export type Coupon = {
  id: string;
  name: string;
};

export type StripePromoCode = {
  active: boolean;
  code: string;
  coupon: {
    id: string;
    name: string;
    metadata: {
      organization_id?: string;
    };
    applies_to: {
      products: string[];
    };
  };
};

type TabOptionsRecord = Record<string, Plans | AddOnItemName>;

export const TabOptions: TabOptionsRecord = {
  [Plans.PRO]: Plans.PRO_YEARLY,
  [Plans.PRO_YEARLY]: Plans.PRO,
  [Plans.VA]: Plans.VA_YEARLY,
  [Plans.VA_YEARLY]: Plans.VA,
  [Plans.AUTOPILOT]: Plans.AUTOPILOT_YEARLY,
  [Plans.AUTOPILOT_YEARLY]: Plans.AUTOPILOT,
  [AddOnItemName.email_volume_monthly]: AddOnItemName.email_volume_yearly,
  [AddOnItemName.email_volume_yearly]: AddOnItemName.email_volume_monthly,
  [AddOnItemName.email_volume_pro_monthly]:
    AddOnItemName.email_volume_pro_yearly,
  [AddOnItemName.email_volume_pro_yearly]:
    AddOnItemName.email_volume_pro_monthly,
};

export type PlanDetailsReturnType = {
  checkout_nam?: string;
  display_name: string;
  description: string;
  product: string;
  price: number;
};

export const SplashPageSourceBackRoute: { [key in SplashPage]: string } = {
  [SplashPage.annual]: `/${routes.annual}`,
  [SplashPage.va]: `/${routes.va}`,
  [SplashPage.pro]: `/${routes.pro}`,
  [SplashPage.pro_bundle]: `${routes.proBundle}`,
  [SplashPage.repitching]: `/${routes.repitching}`,
  [SplashPage.va_money_back]: `/${routes.vaAnnual}`,
  [SplashPage.ooo]: `/${routes.pitchPlease}`,
  [SplashPage.strategy_package]: `/${routes.strategyPackage}`,
  [SplashPage.instagram]: `/${routes.onboardingInstagram}`,
  [SplashPage.va_bundled]: `/${routes.vaBundled}`,
};
